var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 10C18.3672 14.6211 14.6211 18.3672 10 18.3672C5.37893 18.3672 1.63281 14.6211 1.63281 10C1.63281 5.37893 5.37893 1.63281 10 1.63281C14.6211 1.63281 18.3672 5.37893 18.3672 10Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0114 6.4169C9.73945 6.42295 9.47498 6.32788 9.26916 6.1501C9.06318 5.97198 8.96018 5.72016 8.96018 5.39464C8.95643 5.25742 8.98286 5.12105 9.0376 4.99516C9.09234 4.86928 9.17406 4.75695 9.27698 4.66612C9.47652 4.47992 9.74 4.37755 10.0129 4.38018C10.2754 4.37755 10.53 4.46964 10.7301 4.63956C10.9384 4.81221 11.0426 5.06391 11.0426 5.39464C11.0426 5.71495 10.9409 5.96547 10.7375 6.1462C10.5385 6.32515 10.279 6.4219 10.0114 6.4169ZM11.0414 8.56846V14.588C11.0414 15.0047 10.9422 15.32 10.7438 15.5341C10.6483 15.6386 10.5315 15.7214 10.4012 15.7767C10.2709 15.8321 10.1302 15.8587 9.9887 15.8548C9.68323 15.8548 9.43518 15.7454 9.24456 15.5267C9.05393 15.3079 8.95862 14.9954 8.95862 14.5892V8.6294C8.95862 8.21768 9.05393 7.90753 9.24456 7.69893C9.43518 7.49034 9.68323 7.38617 9.9887 7.38643C10.2936 7.38643 10.5453 7.4906 10.7438 7.69893C10.9422 7.90727 11.0414 8.19711 11.0414 8.56846Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteInfo);
export default __webpack_public_path__ + "static/media/white-info.db56fa19f0fd8241738236af5c8e28bf.svg";
export { ForwardRef as ReactComponent };